'use client'

import { useMutation } from '@tanstack/react-query'

import { sendStepUpCode } from '@/service/step-up.api'
import { SendStepUpCodeResponse } from '@/types/generated/common/auth'
import type { ErrorResponse } from '@/types/service'

export const useSendStepUpCode = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (response: SendStepUpCodeResponse) => void
  onError?: (error: ErrorResponse) => void
} = {}) => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: sendStepUpCode,
    onSuccess,
    onError,
  })

  return {
    mutateAsync,
    isPending,
  }
}
